export default function SVG_Quiz() {
  return (
    <div>
      <h1>SVG_Quiz Component</h1>
    </div>
  );
}
